import { ContractService } from '@/services'
import { getResponse } from '@/plugins/store'

export default {
  async createContract({ commit }, params) {
    commit('CREATE_CONTRACT_REQUEST')
    try {
      const { data } = await ContractService.createContract(params)
      commit('CREATE_CONTRACT_SUCCESS', getResponse(data))
    } catch (error) {
      commit('CREATE_CONTRACT_FAILURE', error)
    }
  },
  async getProvinces({ commit }) {
    commit('GET_PROVINCES_REQUEST')
    try {
      const { data } = await ContractService.getProvinces()
      const provinces = getResponse(data) || []
      commit('GET_PROVINCES_SUCCESS', provinces)
    } catch (error) {
      commit('GET_PROVINCES_FAILURE', error)
    }
  },
  async getWards({ commit }, provinceCode) {
    commit('GET_WARDS_REQUEST')
    try {
      const { data } = await ContractService.getWards(provinceCode)
      const wards = getResponse(data) || []
      commit('GET_WARDS_SUCCESS', wards)
    } catch (error) {
      commit('GET_WARDS_FAILURE', error)
    }
  },
  async getContract({ commit, getters }) {
    commit('GET_CONTRACT_REQUEST')
    try {
      const { data } = await ContractService.getContract()
      const contractData = getResponse(data)
      commit('GET_CONTRACT_SUCCESS', contractData)
      return getters.contract
    } catch (error) {
      commit('GET_CONTRACT_FAILURE', error)
      throw error
    }
  },
  async updateContract({ commit }, params) {
    commit('UPDATE_CONTRACT_REQUEST')
    try {
      const { data } = await ContractService.updateContract(params)
      commit('UPDATE_CONTRACT_SUCCESS', getResponse(data))
    } catch (error) {
      commit('UPDATE_CONTRACT_FAILURE', error)
    }
  },
}
